import React from 'react';
import styled from 'styled-components';
import Collapse from '@material-ui/core/Collapse';
import ChildLocationDetails from './ChildLocationDetails';
import {PrimaryButton, ButtonRow} from '../../../components/Buttons';

const ChildLocationRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 40px;
  margin-bottom: 20px;
  align-items: center;
  grid-gap: 5px;
`;

const Image = styled.img`
  width: 100px;
  height: 60px;
  object-fit: cover;
`;

const Name = styled.span`
  font-size: 14px;
  letter-spacing: 0.02px;
  vertical-align: middle;
`;

const Icon = styled.i`
  text-align: right;
`;

const LineDivider = styled.hr`
  height: 1px;
  background-color: #ebebeb;
  margin-bottom: 20px;
`;

const ChildLocationDetailsCollapse = styled(Collapse)``;

const ChildLocations = ({
  subBusiness,
  idOfExpandedChildLocationPreview,
  setIdOfExpandedChildLocationPreview,
}) => {
  const isExpanded = idOfExpandedChildLocationPreview == subBusiness.id;

  const handleClick = e => {
    e.stopPropagation();
    setIdOfExpandedChildLocationPreview(subBusiness.id);
  };

  return (
    <div onClick={e => handleClick(e)}>
      <ChildLocationRow>
        <Image src={subBusiness.image_url}></Image>
        <Name>{subBusiness.name}</Name>
        <Icon className={`fal fa-chevron-${isExpanded ? 'down' : 'right'}`} />
      </ChildLocationRow>

      <ChildLocationDetailsCollapse in={isExpanded}>
        <ChildLocationDetails location={subBusiness} />
      </ChildLocationDetailsCollapse>
      <LineDivider />
    </div>
  );
};

export default ChildLocations;
